<template>
  <div v-if="dialogVisible">
    <el-dialog :title="$t('lang.groupinglist.loadData')" :visible.sync="dialogVisible" width="40%" center>
      <div style="display: flex; justify-content: center;">
        <el-form :model="groupData" :rules="rules" ref="grouForm" label-position="right" label-width="120px">
          <el-form-item :label="`${$t('lang.groupinglist.GroupName')}：`" prop="newgroupingname">
            <el-input 
              size="mini" 
              class="form-input" 
              v-model="groupData.newgroupingname" 
              :placeholder="$t('lang.groupinglist.Standard')">
            </el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.groupinglist.belonging')}：`" v-if="user_iscustomer == 2 || user_iscustomer == 1 && user_ctid == 0">
            <el-select 
              v-model="groupData.cid" 
              :placeholder="$t('lang.groupinglist.Optional')" 
              filterable 
              clearable 
              size="mini" 
              class="form-input"
              @change="customerChange">
              <el-option
                v-for="item in Customer"
                :key="item.c_id"
                :label="item.c_name"
                :value="(item.c_id).toString()"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="`${$t('lang.groupinglist.contact_to')}：`" v-if="user_iscustomer==0||user_ctid!=0">
            <el-select 
              v-model="groupData.uid" 
              @change="userChange"
              :placeholder="$t('lang.groupinglist.Optional')" 
              filterable 
              clearable 
              size="mini" 
              class="form-input">
              <el-option 
                v-for="item in UserList" 
                :key="item.user_id" 
                :label="item.username"
                :value="(item.user_id).toString()">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="`${$t('lang.groupinglist.group1')}：`">
            <el-select
              v-model="groupData.group_level1"
              value-key="group_id"
              filterable
              clearable
              :placeholder="$t('lang.groupinglist.selector')"
              size="mini"
              class="form-input"
              @change="groupOneChane">
              <el-option 
                v-for="item in queryResult" 
                :key="item.group_id" 
                :label="item.group_name" 
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="`${$t('lang.groupinglist.group2')}：`" v-if="groupData.group_level1.group_id">
            <el-select
              v-model="groupData.group_level2"
              filterable
              clearable
              value-key="group_id"
              :placeholder="$t('lang.groupinglist.Choose')"
              size="mini"
              class="form-input">
              <el-option 
                v-for="item in groupList" 
                :key="item.group_id" 
                :label="item.group_name" 
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">{{$t('lang.groupinglist.cancel')}}</el-button>
        <el-button size="mini" type="primary" @click="addnewgroupingname()">{{$t('lang.groupinglist.Determine')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getuser_iscustomer, getuser_ctid, getuser_id } from "@/localStorage/localStorage";
import {addGroup, getCustomerList, getAddLevel3Group, getUserList, getByCustomer, getByUser} from "@/api/groupinglist";
export default {
  data() {
    return {
      dialogVisible: false,
      user_iscustomer: getuser_iscustomer(),
      user_ctid: getuser_ctid(),
      // 当前登录用户的id
      user_id: getuser_id(),
      Customer: [],
      //后端返回的一级分组列表
      queryResult: [],
      //用户选中获取到二级分组列表
      groupList: [],
      UserList: [],
      groupData: {
        newgroupingname: '',
        cid: '',
        uid: '',
        group_level1: { group_id: '' },
        group_level2: { group_id: '' },
      },
      // 表单规则
      rules: {
        newgroupingname: [
          { required: true, message: '请输入分组名称', trigger: 'blur'}
        ]
      }
    }
  },
  methods:{
     show(){
      this.clearData()
      if( this.user_iscustomer == 2 || this.user_iscustomer ==1 && this.user_ctid ==0 ){
        // 获取所有客户
        this.getCustomer()
        // 根据客户id 查询一级分组
        // this.groupData.cid = this.groupData.cid ? this.groupData.cid : this.user_id
        this.fetchByCustomer()
      }else if(this.user_iscustomer == 0 || this.user_ctid !=0 ){
        // 获取所有用户
        this.getUser()
        // 根据用户id 查询一级分组
        this.groupData.uid = this.groupData.uid ? this.groupData.uid : this.user_id
        this.fetchByUser()
      }
      this.dialogVisible = true
    },
    // 获取客户
    getCustomer() {
      //获取客户列表
      getCustomerList().then(res => {
        this.Customer = res.data.data.list;
      });
    },
    // 获取用户
    getUser() {
      getUserList().then(res => {
        this.UserList = res.data.data.list;
      });
    },
    // 根据客户ID查询一级分组
    fetchByCustomer() {
      this.queryResult = []
      getByCustomer(this.groupData.cid).then(res => {
        if(res.data.code === 0) {
          this.queryResult = res.data.data
        }
      })
    },
    // 根据用户ID查询一级分组
    fetchByUser() {
      this.queryResult = []
      getByUser(this.groupData.uid).then(res => {
        if(res.data.code === 0) {
          this.queryResult = res.data.data
        }
      })
    },
    // 一级分组发生变化
    groupOneChane(val) {
      // 清除原来的二级分组选择
      this.groupData.group_level2 = { group_id: '' }
      // 获取二级分组
      this.getTwoGroup()
    },
    // 客户选择发生变化
    customerChange(val) {
      // 清空原来的一二级分组选择
      this.groupData.group_level1 = { group_id: '' }
      this.groupData.group_level2 = { group_id: '' }
      this.fetchByCustomer()
    },
    // 用户选择发生变化
    userChange(val) {
       // 清空原来的一二级分组选择
      this.groupData.group_level1 = { group_id: '' }
      this.groupData.group_level2 = { group_id: '' }
      this.fetchByUser()
    },
    // 根据一级分组获取二级分组
    getTwoGroup() {
      if(this.groupData.group_level1.group_id) {
        getAddLevel3Group(this.groupData.group_level1.group_id).then(res => {
          this.groupList = res.data.queryResult
        })
      }
    },
    // 新增后清空数据
    clearData() {
      this.groupData = {
        newgroupingname: '',
        cid: '',
        uid: '',
        group_level1: { group_id: '' },
        group_level2: { group_id: '' },
      }
    },
     //新增分组
    addnewgroupingname() {
      this.$refs.grouForm.validate(valid => {
        if(valid) {
          let submitData = {}
          // 选择了二级分组
          if(this.groupData.group_level2.group_id) {
            // 当前分组的父级分组为二级分组的id
            submitData.parentGroupId = this.groupData.group_level2.group_id
            submitData.group_level = this.groupData.group_level2.group_level + 1
          }else {
            // 选择了一级分组
            if(this.groupData.group_level1.group_id){ 
              // 当前添加的父级分组为一级分组
              submitData.parentGroupId = this.groupData.group_level1.group_id
              // submitData.group_level = this.groupData.group_level1.group_level + 1
              submitData.group_level = 2
            }else{ // 没有选择一级分组,，当前添加的分组为一级分组
              submitData.parentGroupId = 0
              submitData.group_level = 1
            }
          }
          addGroup(
            this.groupData.newgroupingname,
            submitData.group_level,
            submitData.parentGroupId,
            this.groupData.cid,
            this.superlink,
            this.groupData.uid
          ).then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: this.$t("lang.groupinglist.message13"),
                type: "success"
              });
            } else if (res.data.code === 21) {
              this.$message({
                message: this.$t("lang.groupinglist.message5"),
                type: "warning"
              });
            } else {
              this.$message({
                message: this.$t("lang.groupinglist.message14"),
                type: "warning"
              });
            }
            this.$emit('queryKeyword')
            this.$emit('reFleshTable', submitData.parentGroupId)
            this.dialogVisible = false
          });
        }else{
          return false
        }
      })
    },
  }
}
</script>
<style scoped>
.form-item{
  margin-bottom: 10px;
}
.tetxp {
  display: inline-block;
  width: 2.5rem;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  text-align: right;
}
.form-input {
  width: 4rem;
  
}
</style>